import { getApiClient } from '@signalvote/api-client';
import type { CreateResourceLinkRequest, ResourceLinkDto, UpdateResourceLinkRequest } from '@signalvote/shared';
import { defineQuery, defineWrite, requireSelectedCampaign } from '../../lib/data';

const api = getApiClient();

/** The campaign's resource links; a write naming a resource link refreshes them. */
export const useResources = defineQuery({
  key: () => ['resources', 'list'],
  reads: 'GET /api/ResourceLinks',
  fetch: (_: undefined, { campaignId }): Promise<ResourceLinkDto[]> => {
    requireSelectedCampaign(campaignId);
    return api.resourceLinks.getResourceLinks();
  },
});

export const useCreateResource = defineWrite({
  send: (data: CreateResourceLinkRequest) => api.resourceLinks.createResourceLink(data),
});

export const useUpdateResource = defineWrite({
  send: ({ id, updates }: { id: string; updates: UpdateResourceLinkRequest }) =>
    api.resourceLinks.updateResourceLink(id, updates),
});

export const useDeleteResource = defineWrite({ send: (id: string) => api.resourceLinks.deleteResourceLink(id) });
